import { render, staticRenderFns } from "./ReceptionDetailPage.vue?vue&type=template&id=faeecdfa&scoped=true"
import script from "./ReceptionDetailPage.vue?vue&type=script&lang=js"
export * from "./ReceptionDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ReceptionDetailPage.vue?vue&type=style&index=0&id=faeecdfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faeecdfa",
  null
  
)

export default component.exports